/* import __COLOCATED_TEMPLATE__ from './report-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();